export default __webpack_public_path__ + "static/media/flag-sint-maarten-(dutch-part).2afd4657.svg";